import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { sdkEventBus } from "@/sdk";

export type Location = {
    state?: string;
    city?: string;
    timezone?: string;
};

export type RapportQuestionsState = {
    questions: string[][];
    location?: Location;
};

export type RapportQuestionsActions = {
    hasQuestions: () => boolean;
    hasLocation: () => boolean;

    updateQuestions: (questions: string[][]) => void;
    updateLocation: (location: Location) => void;

    reset(): void;
};

export type RapportBuildingStore = RapportQuestionsState & RapportQuestionsActions;

export const INITIAL_STATE: RapportQuestionsState = {
    questions: [],
    location: undefined,
};

export const useRapportBuildingStore = create<RapportBuildingStore>()(
    persist(
        devtools(
            (set, get) => ({
                ...INITIAL_STATE,

                hasQuestions: () => get().questions.length !== 0,
                hasLocation: () => {
                    const { location } = get();
                    if (location == null) {
                        return false;
                    }
                    const { city, state, timezone } = location;
                    return city || state || timezone;
                },

                updateQuestions: (questions: string[][]) => set({ questions }),
                updateLocation: (location: Location) => set({ location }),

                reset: () => set(INITIAL_STATE),
            }),
            {
                enabled: import.meta.env.VITE_ENV_TYPE !== "production",
                store: "rapport-questions",
                name: "workspace/sales-tools",
            },
        ),
        {
            name: "rapport-questions",
        },
    ),
);

sdkEventBus.on("session_changed", ({ action }) => {
    if (action === "end") {
        useRapportBuildingStore.getState().reset();
    }
});
